import { render, staticRenderFns } from "./WishList.vue?vue&type=template&id=d82b6fe2&scoped=true"
import script from "./WishList.vue?vue&type=script&lang=js"
export * from "./WishList.vue?vue&type=script&lang=js"
import style0 from "./WishList.vue?vue&type=style&index=0&id=d82b6fe2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82b6fe2",
  null
  
)

export default component.exports